<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import LessThan10 from "@/components/standard/Comite/LessThan10";
import GreaterThan10 from "@/components/standard/Comite/GreaterThan10";
import PhotoEvidence from "@/components/standard/PhotoEvidence";
import CompanyAPI from "@/services/company/companyAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.8 Comité de convivencia laboral",
  },
  components: {
    Layout,
    Style,
    PageHeader,
    LessThan10,
    GreaterThan10,
    PhotoEvidence,
  },
  data() {
    return {
      title: "1.1.8 Comité de convivencia laboral",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.8 Comité de convivencia",
          active: true,
        },
      ],
      employeeList: 0,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading: true,
      item: null,
    };
  },
  methods: {
    getEmployeesCount() {
      CompanyAPI.employeesCount(this.companyID)
        .then((response) => {
          this.employeeList = response.companies.employees_count || 0;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getEmployeesCount();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="animated animatedFadeInUp fadeInUp">
      <div v-if="!loading && classificationID <= 4">
        <div class="text-right mb-2">
          <router-link
            :to="`/forms/estandares/${companyID}/informe-trimestral-convivencia`"
            class="btn btn-primary"
          >
            <i class="mdi mdi-file-document-outline"></i> Informe trimestral para gerencia
          </router-link>
        </div>
        <b-card>
          <b-card-body>
            <GreaterThan10 :companyID="companyID" />
          </b-card-body>
        </b-card>
        <PhotoEvidence
          :company-id="companyID"
          item-code="1.1.8"
          category="socializacion"
          title="Evidencia fotográfica de socialización (Comité de Convivencia)"
          help-text="Adjunta fotografías de la socialización, conformación o reuniones del Comité de Convivencia Laboral."
        />
      </div>

      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </Layout>
</template>
